(() => {
  const createHandlingFee = ({ variantId, request, root }) => {
    const isFee = (item) => Number(item.variant_id) === Number(variantId) || item.handle === 'jamos-handling-fee';
    const merchandiseCount = (cart) => cart.items.filter((item) => !isFee(item)).reduce((sum, item) => sum + item.quantity, 0);
    const read = () => request(`${root}cart.js`);
    const post = (path, body) => request(`${root}cart/${path}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    });
    let queue = Promise.resolve();
    const synchronize = async () => {
      let cart = await read();
      const required = merchandiseCount(cart) > 0;
      if (required && !variantId) throw new Error('Handling fee unavailable');
      let fees = cart.items.filter(isFee);
      if (required && !fees.length) {
        await post('add', { items: [{ id: Number(variantId), quantity: 1 }] });
        cart = await read();
        fees = cart.items.filter(isFee);
      }
      const updates = {};
      fees.forEach((item, index) => {
        const quantity = required && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) {
        await post('update', { updates });
        cart = await read();
      }
      const finalFees = cart.items.filter(isFee);
      if (required && (finalFees.length !== 1 || finalFees[0].quantity !== 1 || finalFees[0].original_price !== 595)) {
        throw new Error('Handling fee could not be verified');
      }
      if (!required && finalFees.length) throw new Error('Empty cart fee could not be removed');
      return cart;
    };
    const transact = (operation) => {
      const result = queue.then(async () => {
        if (operation) await operation();
        return synchronize();
      });
      queue = result.catch(() => {});
      return result;
    };
    return { isFee, merchandiseCount, transact, sync: () => transact() };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = createHandlingFee;
  else window.createJamosHandlingFee = createHandlingFee;
})();
